import React, { memo, useEffect } from "react";
import { Button, useMutation, useNotify } from "react-admin";
import { useForm } from "react-final-form";
import MonetizationOnIcon from "@material-ui/icons/MonetizationOn";

interface CalculationButtonProps {
  invalid: boolean;
  setResultRegularCalculations: any;
  setResultCcaCalculations: any;
  setIsLoaded: (isLoaded: boolean) => void;
  setIsCalculationButtonClicked: (isLoaded: boolean) => void;
  formData: formUpdateSchedule;
}

const CalculationButton = ({
  invalid,
  setResultRegularCalculations,
  setResultCcaCalculations,
  setIsLoaded,
  setIsCalculationButtonClicked,
  formData,
}: CalculationButtonProps) => {
  const notify = useNotify();
  const formValues = useForm().getState().values;

  useEffect(() => {
    setIsLoaded(false);
    setIsCalculationButtonClicked(false);

    delete formData.commercialDocumentTags;
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [
    formData.studentId,
    formData.academicYearId,
    formData.startedAt,
    formData.endedAt,
    formData.isNotTaking,
    formData.street,
    formData.postalCode,
    formData.wayType,
    formData.isApplyStudentSubsidy,
    formData.subsidyPercentage,
  ]);

  const [HandleCalculationCost, { loading }] = useMutation(
    {
      type: "create",
      resource: "CostPreview/updateSchedule",
      payload: {
        data: {
          studentId: formValues.studentId,
          academicYearId: formValues.academicYearId,
          startedAt: formValues.startedAt,
          endedAt: formValues.endedAt,
          isTaking: formValues.isNotTaking === true ? false : true,
          isApplyStudentSubsidy: formValues.isApplyStudentSubsidy,
          subsidyPercentage: formValues.isApplyStudentSubsidy
            ? formValues.subsidyPercentage
            : 0,
          detail:
            formValues.isNotTaking === false
              ? {
                  lat: formValues.locationData?.LATITUDE,
                  lng: formValues.locationData?.LONGITUDE,
                  street: formValues.street,
                  unitNumber: formValues.unitNumber,
                  blockNumber: formValues.blockNumber,
                  postalCode: formValues.postalCode,
                  building: formValues.building,
                  isMonday: formValues.isMonday ? true : false,
                  isTuesday: formValues.isTuesday ? true : false,
                  isWednesday: formValues.isWednesday ? true : false,
                  isThursday: formValues.isThursday ? true : false,
                  isFriday: formValues.isFriday ? true : false,
                  isFromSchool:
                    formValues.wayType === "OneWayMorning" ? false : true,
                  isToSchool:
                    formValues.wayType === "OneWayAfternoon" ? false : true,
                }
              : null,
        },
      },
    },
    {
      onSuccess: ({ res }) => {
        setResultRegularCalculations(res.json.updateRegularScheduleResponse);
        setResultCcaCalculations(res.json.updateCcaScheduleResponse);
        setIsLoaded(true);
        setIsCalculationButtonClicked(true);
      },
      onFailure: (error) => {
        notify(`Failed Calculation Cost, error: ${error.message}`, "warning");
        setResultRegularCalculations([]);
        setResultCcaCalculations([]);
      },
    },
  );

  const CalculationCostButtonStyle = {
    padding: "7px 16px",
  };

  return (
    <Button
      label={loading ? `Loading...` : `Calculation Cost`}
      style={CalculationCostButtonStyle}
      onClick={HandleCalculationCost}
      disabled={invalid}
    >
      <MonetizationOnIcon />
    </Button>
  );
};

export default memo(CalculationButton);
